import { MarketSelectionType } from "smartstream-widgets/types/market"

export function getMarketHandicap(selection: MarketSelectionType) {
  const { handicap, outcome } = selection || {}

  if (outcome &&
    ['OVER', 'UNDER'].includes(outcome.toUpperCase()) && handicap) {
    return `${handicap}`
  }

  if (outcome && outcome.toUpperCase() === 'DRAW') {
    return ''
   }

  if (handicap) {
    return Math.sign(handicap) >= 0 ? `+${handicap}` : handicap
  }

  return ''
}

export function getMarketOutcome(selection: MarketSelectionType) {
  const { outcome, handicap, name } = selection || {}

  if (outcome &&
    ['OVER', 'UNDER'].includes(outcome.toUpperCase()) && handicap){
    const prefix = outcome.toUpperCase() === 'OVER' ? 'O' : 'U'
    return prefix
  }

  if (outcome && outcome.toUpperCase() === 'DRAW') {
   return `${outcome}`
  }

  const isHomeOrAway = /home|away/i.test(outcome)
  if (name && !isHomeOrAway) {
    return name
  }

  return ''
}